import {
    handleAvailable,
    handleRequest,
    handleUnavailable,
} from '../reducerHandlers';
import { createReducer } from './utils';
import {
    TASKS_SUGGESTIONS_REQUEST,
    TASKS_SUGGESTIONS_AVAILABLE,
    TASKS_SUGGESTIONS_UNAVAILABLE,
    SNACK_SET,
} from './constants';

const defaultState = {
    loadingSuggestions: false,
    suggestedTasks: [],
    suggestedForScopeId: null,
    error: null,
};

export const reducer = createReducer(defaultState, {
    [TASKS_SUGGESTIONS_REQUEST]: handleRequest,
    [TASKS_SUGGESTIONS_AVAILABLE]: handleAvailable,
    [TASKS_SUGGESTIONS_UNAVAILABLE]: handleUnavailable,
});

export function fetchTaskSuggestions({ file_url, scope_id, project_id }) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'suggestedTasks';
        const loadingName = 'loadingSuggestions';

        dispatch({
            type: TASKS_SUGGESTIONS_REQUEST,
            payload: { loadingName },
            additionalStates: {
                [keyState]: [],
                suggestedForScopeId: null
            }
        });

        try {
            const response = await dataSource.getTaskSuggestions(file_url, scope_id, project_id);

            let data = response;
            if (Array.isArray(response)) {
                data = response.flat();
            }

            const isEmptySuggestions = !data || data.length === 0;

            dispatch({
                type: TASKS_SUGGESTIONS_AVAILABLE,
                payload: {
                    keyState,
                    data: data,
                    loadingName,
                    additionalStates: { suggestedForScopeId: scope_id },
                },
            });

            if (isEmptySuggestions) {
                dispatch({
                    type: SNACK_SET,
                    payload: {
                        snack: {
                            open: true,
                            message: 'No new task suggestions available.',
                            severity: 'warning',
                            isAiResult: true,
                        },
                    },
                });
            }
        } catch (error) {
            dispatch({
                type: TASKS_SUGGESTIONS_UNAVAILABLE,
                payload: {
                    keyState,
                    loadingName,
                    defaultState: [],
                    error: error.response?.data || error.message,
                    additionalStates: { suggestedForScopeId: null },
                },
            });

            dispatch({
                type: SNACK_SET,
                payload: {
                    snack: {
                        open: true,
                        message: 'Error fetching task suggestions.',
                        severity: 'error',
                    },
                },
            });
        }
    };
}

export function saveSuggestedTasks({ scope_id, project_id, created_by, tasks }) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const loadingName = 'loadingSuggestions';

        dispatch({
            type: TASKS_SUGGESTIONS_REQUEST,
            payload: { loadingName },
        });

        try {
            const response = await dataSource.saveSuggestedTasks({
                scope_id,
                project_id,
                created_by,
                tasks,
            });

            dispatch({
                type: TASKS_SUGGESTIONS_AVAILABLE,
                payload: {
                    keyState: 'suggestedTasks',
                    data: [],
                    loadingName,
                    additionalStates: { suggestedForScopeId: null },
                },
            });

            dispatch({
                type: SNACK_SET,
                payload: {
                    snack: {
                        open: true,
                        message: response.message,
                        severity: response.status_type,
                    },
                },
            });

            return response;
        } catch (error) {
            dispatch({
                type: TASKS_SUGGESTIONS_UNAVAILABLE,
                payload: {
                    loadingName,
                    error: error.response?.data || error.message,
                    additionalStates: { suggestedForScopeId: null },
                },
            });

            dispatch({
                type: SNACK_SET,
                payload: {
                    snack: {
                        open: true,
                        message: 'Error saving tasks.',
                        severity: 'error',
                    },
                },
            });
            throw error;
        }
    };
}
